import React, { useState } from "react";
import Context from "../../context";
import openApp from "../../action/open_app";

export default function Search(props) {
  const [state] = useState({
    container:
      "fixed text-white bg-black left-0 bottom-0 w-full md:w-4/5 lg:w-3/5 transition-all duration-500"
  });
  const [tabs, settab] = useState({
    list: ["All", "Apps", "Documents", "Web"],
    active: "All"
  });
  const [selectSearch, setselectsearch] = useState("");
  const [searched, setSearch] = useState(null);
  return (
    <div
      className={state.container + " mb-12 pb-1"}
      style={props.open ? {} : { marginBottom: "-200vh" }}
    >
      <div className="flex flex-wrap">
        <div className="flex w-full border-b border-gray-900">
          {tabs.list.map((d, i) => (
            <h6
              onClick={(e) => {
                settab({
                  list: tabs.list,
                  active: d
                });
                setselectsearch("");
              }}
              key={i}
              className={
                tabs.active === d
                  ? "p-4 bg-gray-900 cursor-pointer hover:bg-gray-900 transition-all duration-500"
                  : "p-4 cursor-pointer hover:bg-gray-900 transition-all duration-500"
              }
            >
              {d}
            </h6>
          ))}
        </div>
        <div className="flex w-full">
          <div className="w-2/5 h-48 overflow-auto">
            {tabs.active === "All" ? (
              <ul>
                <Context.Consumer>
                  {(data) => {
                    return data.app
                      .filter((d) => d.indexOf(searched) !== -1)
                      .sort()
                      .map((d, i) => (
                        <li
                          key={i}
                          onDoubleClick={(e) => openApp(data, d)}
                          onClick={(e) => setselectsearch(d)}
                          className={
                            selectSearch === d
                              ? "p-2 border-b cursor-pointer hover:bg-gray-900 transition-all duration-500 bg-gray-900"
                              : "p-2 border-b cursor-pointer hover:bg-gray-900 transition-all duration-500"
                          }
                        >
                          {d}
                        </li>
                      ));
                  }}
                </Context.Consumer>
              </ul>
            ) : (
              false
            )}
            {tabs.active === "Apps" ? (
              <ul>
                <Context.Consumer>
                  {(data) => {
                    return data.app
                      .filter((d) => d.indexOf(searched) !== -1)
                      .sort()
                      .map((d, i) => (
                        <li
                          key={i}
                          onDoubleClick={(e) => openApp(data, d)}
                          onClick={(e) => setselectsearch(d)}
                          className={
                            selectSearch === d
                              ? "p-2 border-b cursor-pointer hover:bg-gray-900 transition-all duration-500 bg-gray-900"
                              : "p-2 border-b cursor-pointer hover:bg-gray-900 transition-all duration-500"
                          }
                        >
                          {d}
                        </li>
                      ));
                  }}
                </Context.Consumer>
              </ul>
            ) : (
              false
            )}
          </div>
          <div className="w-3/5 p-2 bg-gray-900">
            {selectSearch ? (
              <>
                <h3 className="text-center text-xl">{selectSearch}</h3>
                <div className="flex flex-wrap">
                  <Context.Consumer>
                    {(data) => (
                      <a
                        onClick={(e) => {
                          e.preventDefault();
                          setselectsearch("");
                          setSearch(null);
                          openApp(data, selectSearch);
                        }}
                        className="w-full p-3 hover:underline"
                        href="/"
                      >
                        Open
                      </a>
                    )}
                  </Context.Consumer>
                  <a className="w-full p-3 hover:underline" href="/">
                    Open In Directory
                  </a>
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      window.open(
                        "https://google.com/search?q=" +
                          selectSearch.toLowerCase()
                      );
                    }}
                    className="w-full p-3 hover:underline"
                    href="/"
                  >
                    Search On Web
                  </a>
                </div>
              </>
            ) : (
              false
            )}
          </div>
        </div>
        <div className="flex w-full">
          <form className="w-full" onSubmit={(e) => e.preventDefault()}>
            <input
              className="p-3 w-full text-black focus:outline-none"
              type="search"
              placeholder="Type here to search..."
              onKeyUp={(e) =>
                e.target.value.length === 0
                  ? setSearch(null)
                  : setSearch(e.target.value)
              }
            />
          </form>
        </div>
      </div>
    </div>
  );
}
